import api from '@/utils/api'

export default {
    login(data) {
        return api.post(`users/login`, data)
    },
    refreshToken(data) {
        return api.post(`users/refresh-token`, data)
    },
    banUser(id) {
        return api.post(`users/${id}/ban`)
    },
    getAllUsers() {
        return api.get('users/all')
    },
    getAllUserRoles() {
        return api.get('users/roles')
    },
    updateUser(id, data) {
        return api.put(`users/${id}`, data)
    },

    getUserById(id) {
        return api.get(`users/${id}`)
    },
    getUsers(page, size, query, sort) {
        let filter = null
        Object.keys(query).forEach(key => {
            if (!query[key]) {
                delete query[key]
            }
        })
        if (Object.keys(query).length > 0) {
            filter = query
        }
        let range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
        return api.get(`users` + (page ? range : '') + (filter ? `&filter=${encodeURIComponent(JSON.stringify(filter))}` : '') + (sort ? `&sort=${encodeURIComponent(sort)}` : ''))
    },
    getCurrentUser() {
        return api.get('users/current')
    },
    getContractorUsers(contractorId) {
        return api.get(`users/contractor/${contractorId}`)
    },
    createUser(data) {
        return api.post(`users/create`, data)
    }
}
